export default __webpack_public_path__ + "static/media/patient-small-blue.9b93bd42.svg";